import { createSelector } from 'reselect';
export const selectProfileFeatureState = (state) => state.profile;

export const selectUserProfile = createSelector(
  selectProfileFeatureState,
  (state) => state.userProfile
);

export const selectWorkAddress = createSelector(
  selectUserProfile,
  (state) => state && state.WorkAddress
);

export const selectHomeAddress = createSelector(
  selectUserProfile,
  (state) => state && state.HomeAddress
);

export const isExpenseAllowed = createSelector(
  selectUserProfile,
  (state) => state && state.IsExpenseAllowed
);

export const selectUserProfileImage = createSelector(selectUserProfile, (state) =>
  state && state.ImageBytes ? `${state.ImageBytes}?bust=${new Date().getMinutes()}` : null
);

export const selectShowHomepagePopupforOneWay = createSelector(selectUserProfile, (state) =>
  state && state.IsHomepageUDIDforOneWayJourney ? state.IsHomepageUDIDforOneWayJourney : false
);

export const selectHomepageOnewayPopupDetails = createSelector(selectUserProfile, (state) =>
  state && state?.HomepageOneWayUDIDdetails && state?.HomepageOneWayUDIDdetails?.length > 0
    ? state.HomepageOneWayUDIDdetails
    : []
);
